export type WorkspaceListResponse = WorkspaceApiResponse[];

export type WorkspaceCreateResponse = WorkspaceApiResponse;

export type WorkspaceGetPublicResponse = WorkspaceApiResponse[];

export interface WorkspaceApiResponse {
  id: number;
  created_iso: string;
  creator_id: number;
  creator_name: string;
  data_filters: WorkspaceApiDataFilter;
  description: string;
  has_all_org_members: boolean;
  is_global: boolean;
  is_default: boolean;
  membership_approval_required: boolean;
  name: string;
  project_id: number;
  requesting_user_orgs: string[];
  requesting_user_teams: string[];
  team_list: WorkspaceTeam[];
  unified_member_list: WorkspaceApiUnifiedMember[];

  // permissions
  can_view: boolean;
  can_update_basic: boolean;
  can_share: boolean;

  // sharing-disabled (visibility controls in create-entity-modal)
  is_visible: boolean;
  is_restricted: boolean;
  can_update_visibility: boolean;
  can_update_restricted: boolean;
}

export interface WorkspaceApiDataFilter {
  event_names: {
    inclusion_type: string;
    filter: string[];
  };
  event_properties: any;
  user_properties: any;
}

export interface WorkspaceApiUnifiedMember {
  membership_type: UnifiedMembershipType;
  org_name: string;
  name: string;
  id: number;
  invited: boolean;
  team_name: string;
  email: string;
  entity_type: string;
}

export enum UnifiedMembershipType {
  Individual = `individual`,
  Organization = `organization`,
  Team = `team`,
}

export interface WorkspaceTeam {
  id: number;
  name: string;
}
